export enum StudentAccountStatus {
  AccountNotCreated,
  Invited,
  AccountCreated,
}

export const StudentAccountStatusNames: { [key: number]: string } = {
  0: 'Account not created',
  1: 'Account not created (Invite sent)',
  2: 'Account Created',
};
